import React from "react";
import { CheckSquare, X, Download, Trash2 } from "lucide-react";

const SelectionToolbar = ({
  selectedPhotos,
  selectAllPhotos,
  deselectAllPhotos,
  handleDownloadSelected,
  handleDeleteSelected,
  isMainAdmin,
}) => {
  if (selectedPhotos.size === 0) return null;

  return (
    <div className="selection-toolbar">
      <span className="selection-badge">
        {selectedPhotos.size}<span className="hide-on-mobile"> Selected</span>
      </span>
      <div className="toolbar-actions">
        <button
          className="toolbar-btn select-all-btn"
          onClick={selectAllPhotos}
          title="Select All"
          aria-label="Select All"
        >
          <CheckSquare size={18} className="lucide-icon" /><span className="hide-on-mobile"> Select All</span>
        </button>
        <button
          className="toolbar-btn clear-btn"
          onClick={deselectAllPhotos}
          title="Clear Selection"
          aria-label="Clear Selection"
        >
          <X size={18} className="lucide-icon" /><span className="hide-on-mobile"> Clear</span>
        </button>
        <button
          className="toolbar-btn download-btn"
          onClick={handleDownloadSelected}
          title="Download Selected"
          aria-label="Download Selected"
        >
          <Download size={18} className="lucide-icon" /><span className="hide-on-mobile"> Download ({selectedPhotos.size})</span>
        </button>
        {isMainAdmin && (
          <button
            className="toolbar-btn delete-btn"
            onClick={handleDeleteSelected}
            style={{ backgroundColor: "#ff4d4f", color: "white" }}
            title="Delete Selected"
            aria-label="Delete Selected"
          >
            <Trash2 size={18} className="lucide-icon" /><span className="hide-on-mobile"> Delete ({selectedPhotos.size})</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SelectionToolbar;
